import React from "react";
import styled from "styled-components";
import { Button as ButtonPrimitive } from "../primitives/Button";
import { colors, sizes, typeface } from "../theme";

// Constants
const DEFAULT_PADDING = "0.7rem";
const ICON_ONLY_PADDING = "0.4rem";
const ICON_MARGIN = "0.7rem";

// Exports
export interface ButtonProps
  extends React.InputHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  iconSize?: string;
  iconLeft?: boolean;
  iconRight?: boolean;
  iconOnly?: boolean;
  selected?: boolean;
  noBorder?: boolean;
}
export const Button = styled(ButtonPrimitive)<ButtonProps>`
  border-radius: 0.3rem;
  font-family: ${typeface.primary};
  font-size: 1rem;
  background: ${props => (props.selected ? colors.blue7 : colors.white)};
  border: 1px solid ${props => (props.selected ? colors.blue7 : colors.grayE)};
  border-color: ${props => props.noBorder && "transparent"};
  color: ${props => (props.selected ? colors.white : colors.gray1)};
  font-weight: normal;
  height: 2.3rem;
  justify-content: ${props => props.fullWidth && "space-between"};
  padding-left: ${props => {
    if (props.iconOnly) return ICON_ONLY_PADDING;
    if (props.iconLeft) return "0";
    return DEFAULT_PADDING;
  }};
  padding-right: ${props => {
    if (props.iconOnly) return ICON_ONLY_PADDING;
    if (props.iconRight) return "0";
    return DEFAULT_PADDING;
  }};
  width: ${props => props.fullWidth && "100%"};
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: ${props => !props.selected && colors.blueF};
  }

  &:active:not(:disabled) {
    background: ${colors.blue7};
    border: 1px solid ${colors.blue7};
    color: ${colors.white};
  }

  &:disabled {
    color: ${colors.grayA};
    border-color: ${colors.grayF};
  }

  > svg {
    width: ${props => props.iconSize || sizes.iconDefault};
    padding: ${props =>
      props.iconLeft || props.iconRight ? `0 ${ICON_MARGIN}` : "0"};
  }
`;
